var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tool-page"
  }, [_c('Introduce', {
    attrs: {
      "title": _vm.$t('tools.technical-views.title'),
      "titleBefore": _vm.$t('tools.technical-views.title-sm1'),
      "titleSm": _vm.$t('tools.technical-views.title-sm2')
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return [_c('div', {
          staticClass: "content-slot"
        }, [_vm._v(" " + _vm._s(_vm.$t('tools.technical-views.content')) + " ")])];
      },
      proxy: true
    }, {
      key: "button",
      fn: function () {
        return [_c('b-button', {
          staticClass: "custom-btn",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function ($event) {
              return _vm.goToLogin();
            }
          }
        }, [_c('div', {
          staticClass: "text-white-button button-large text-nowrap d-flex justify-content-center"
        }, [_vm._v(" " + _vm._s(_vm.$t("tools.economic-calendar.start-btn")) + " ")])])];
      },
      proxy: true
    }, {
      key: "itemRight",
      fn: function () {
        return [_c('div', {
          staticClass: "layout-right"
        }, [_c('iframe', {
          staticClass: "youtube",
          attrs: {
            "src": "https://www.youtube.com/embed/SfTCZB5pbT0",
            "title": "TC Technical Views - Plan your trades with key levels from Trading Central",
            "frameborder": "0",
            "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
            "referrerpolicy": "strict-origin-when-cross-origin"
          }
        })])];
      },
      proxy: true
    }])
  }), _c('div', {
    staticClass: "title title-tool-page"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.technical-views.begin1")) + " "), _c('span', {
    staticClass: "text-primary"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.technical-views.begin2")) + " ")])]), _c('div', {
    staticClass: "content-item"
  }, [_c('div', {
    staticClass: "content-item__info"
  }, [_c('div', {
    staticClass: "content-item__info__title"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.technical-views.content-item-title1")) + " ")]), _c('div', {
    staticClass: "content-item__info__text"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.technical-views.content-item-text1")) + " "), _c('div', {
    staticClass: "hinde-sm enter-paragraphs"
  }), _vm._v(" " + _vm._s(_vm.$t("tools.technical-views.content-item-text2")) + " "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.technical-views.content-item-text3")) + " ")]), _vm._v(" " + _vm._s(_vm.$t("tools.technical-views.content-item-text4")) + " ")])]), _c('img', {
    attrs: {
      "src": require("@/assets/toolImg/technical.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "content-item"
  }, [_c('img', {
    staticClass: "hinde-md",
    attrs: {
      "src": require("@/assets/toolImg/technical1.png"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "content-item__info"
  }, [_c('div', {
    staticClass: "content-item__info__title"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.technical-views.content-item-title2")) + " ")]), _c('div', {
    staticClass: "content-item__info__text"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.technical-views.content-item-text5")) + " "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.technical-views.content-item-text6")) + " ")]), _vm._v(" " + _vm._s(_vm.$t("tools.technical-views.content-item-text7")) + " ")])]), _c('img', {
    staticClass: "hinde-sm",
    attrs: {
      "src": require("@/assets/toolImg/technical1.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "content-item"
  }, [_c('div', {
    staticClass: "content-item__info"
  }, [_c('div', {
    staticClass: "content-item__info__title"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.technical-views.content-item-title3")) + " ")]), _c('div', {
    staticClass: "content-item__info__text"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.technical-views.content-item-text8")) + " "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.technical-views.content-item-text9")) + " ")]), _vm._v(" " + _vm._s(_vm.$t("tools.technical-views.content-item-text10")) + " "), _c('div', {
    staticClass: "enter-paragraphs"
  }), _vm._v(" " + _vm._s(_vm.$t("tools.technical-views.content-item-text11")) + " "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.technical-views.content-item-text12")) + " ")]), _vm._v(" " + _vm._s(_vm.$t("tools.technical-views.content-item-text13")) + " ")])]), _c('img', {
    attrs: {
      "src": require("@/assets/toolImg/technical2.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "content-item"
  }, [_c('img', {
    staticClass: "hinde-md",
    attrs: {
      "src": require("@/assets/toolImg/calendar3.png"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "content-item__info"
  }, [_c('div', {
    staticClass: "content-item__info__title"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.technical-views.content-item-title4")) + " ")]), _c('div', {
    staticClass: "content-item__info__text"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.technical-views.content-item-text14")) + " "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.technical-views.content-item-text15")) + " ")]), _vm._v(" " + _vm._s(_vm.$t("tools.technical-views.content-item-text16")) + " ")])]), _c('img', {
    staticClass: "hinde-sm",
    attrs: {
      "src": require("@/assets/toolImg/calendar3.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "btn-bottom"
  }, [_c('b-button', {
    staticClass: "custom-btn",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.goToLogin();
      }
    }
  }, [_c('div', {
    staticClass: "text-white-button button-large text-nowrap d-flex justify-content-center"
  }, [_vm._v(" " + _vm._s(_vm.$t("tools.economic-calendar.start-btn")) + " ")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }